import { servers } from 'common';

let settings = {
  apiUrl: `https://${servers.production.hostname}:3000/`
};

if (process.env.NODE_ENV !== 'production') {
  const devSettings = {
    apiUrl: `http://127.0.0.1:3000/`
  };

  settings = R.merge(settings, devSettings);
}

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js